{
  "enums": {
    "claimStatus": {
      "draft": "Draft",
      "submitted": "Submitted",
      "accepted": "Accepted",
      "denied": "Denied",
      "paid": "Paid"
    },
    "chargeStatus": {
      "pending": "Pending",
      "unbilled": "Unbilled",
      "posted": "Posted",
      "billed": "Billed",
      "adjusted": "Adjusted",
      "voided": "Voided"
    },
    "statementDelivery": {
      "print": "Print",
      "email": "Email",
      "both": "Print & Email",
      "mail": "Mail"
    },
    "statementStatus": {
      "generated": "Generated",
      "sent": "Sent",
      "viewed": "Viewed"
    },
    "denialStatus": {
      "new": "New",
      "inReview": "In Review",
      "appealing": "Appealing",
      "resolved": "Resolved",
      "writtenOff": "Written Off"
    },
    "denialPriority": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "claimType": {
      "professional": "Professional",
      "institutional": "Institutional",
      "dental": "Dental",
      "pharmacy": "Pharmacy"
    },
    "paymentMethod": {
      "cash": "Cash",
      "check": "Check",
      "creditCard": "Credit Card",
      "debitCard": "Debit Card",
      "bankTransfer": "Bank Transfer",
      "digitalWallet": "Digital Wallet",
      "insurance": "Insurance"
    },
    "paymentSource": {
      "patient": "Patient",
      "insurance": "Insurance",
      "thirdParty": "Third Party"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "Patient ID is required",
      "encounterIdRequired": "Encounter ID is required",
      "payerIdRequired": "Payer ID is required",
      "chargeCodeRequired": "Charge code is required",
      "unitPriceRequired": "Unit price is required",
      "amountRequired": "Amount is required",
      "amountPositive": "Amount must be greater than zero",
      "chargeSelectionRequired": "Select at least one charge"
    }
  },
  "pages": {
    "statements": {
      "title": "Billing Statements",
      "labels": {
        "dashboard": "Dashboard",
        "patient": "Patient",
        "from": "From",
        "to": "To",
        "batchGenerate": "Batch Generate",
        "previewStatement": "Preview Statement",
        "generatePrint": "Generate & Print",
        "generateEmail": "Generate & Email",
        "printEmail": "Print & Email",
        "print": "Print",
        "email": "Email"
      },
      "placeholders": {
        "searchPatient": "Search by name or MRN..."
      },
      "aria": {
        "periodFrom": "Statement period from",
        "periodTo": "Statement period to"
      },
      "table": {
        "header": {
          "statementHistory": "Statement History",
          "patient": "Patient",
          "mrn": "MRN",
          "date": "Date",
          "amount": "Amount",
          "delivery": "Delivery",
          "status": "Status"
        },
        "preview": {
          "modal": "Statement Preview",
          "patientStatement": "Patient Statement",
          "patient": "Patient:",
          "mrn": "MRN:",
          "statementDate": "Statement Date:",
          "period": "Period:",
          "lineItemHeader": {
            "date": "Date",
            "description": "Description",
            "charges": "Charges",
            "payments": "Payments",
            "balance": "Balance"
          },
          "openingBalance": "Opening Balance",
          "totals": "Totals",
          "amountDue": "Amount Due"
        }
      },
      "states": {
        "generating": "Generating...",
        "loading": "Generating preview...",
        "noPatients": "No patients found",
        "noStatementData": "No statement data available",
        "loadingHistory": "Loading history...",
        "noStatementsGenerated": "No statements generated yet",
        "selectedPatientId": "Selected patient ID: {{id}}"
      },
      "toast": {
        "generated": "Statement generated",
        "generatedError": "Failed to generate statement",
        "batchStarted": "Batch generation started: {{count}} statements queued",
        "batchError": "Failed to start batch generation"
      }
    },
    "claims": {
      "title": "Claims Management",
      "labels": {
        "dashboard": "Dashboard",
        "createClaim": "Create Claim",
        "filters": "Filters",
        "submit": "Submit",
        "appeal": "Appeal",
        "denialReason": "Denial Reason",
        "expandHint": "Expand a claim to view line items in the dedicated claim page.",
        "cancel": "Cancel"
      },
      "filter": {
        "allStatuses": "All Statuses"
      },
      "placeholders": {
        "filterPayer": "Filter by payer..."
      },
      "aria": {
        "claimDateFrom": "Claim date from",
        "claimDateTo": "Claim date to"
      },
      "table": {
        "header": {
          "claimNumber": "Claim #",
          "patient": "Patient",
          "payer": "Payer",
          "total": "Total",
          "status": "Status",
          "submitted": "Submitted",
          "actions": "Actions"
        }
      },
      "modal": {
        "createClaim": "Create Claim from Charges",
        "patientId": "Patient ID *",
        "payerId": "Payer ID *",
        "selectCharges": "Select Charges ({{selected}} selected)",
        "noBilledCharges": "No unbilled charges for this patient"
      },
      "states": {
        "loading": "Loading claims...",
        "noClaims": "No claims found",
        "creating": "Creating..."
      },
      "toast": {
        "created": "Claim created",
        "createdError": "Failed to create claim",
        "submitted": "Claim submitted",
        "submittedError": "Failed to submit claim",
        "resubmitted": "Claim resubmitted for appeal",
        "resubmittedError": "Failed to resubmit claim",
        "patientPayerRequired": "Patient and payer are required",
        "chargeRequired": "Select at least one charge"
      }
    },
    "charges": {
      "title": "Charge Management",
      "labels": {
        "dashboard": "Dashboard",
        "newCharge": "New Charge",
        "totalChargesPeriod": "Total Charges (Period)",
        "filters": "Filters",
        "cancel": "Cancel"
      },
      "filter": {
        "allStatuses": "All Statuses"
      },
      "placeholders": {
        "filterPatient": "Filter by patient..."
      },
      "aria": {
        "serviceDateFrom": "Service date from",
        "serviceDateTo": "Service date to"
      },
      "table": {
        "header": {
          "date": "Date",
          "patient": "Patient",
          "encounter": "Encounter",
          "code": "Code",
          "description": "Description",
          "qty": "Qty",
          "unitPrice": "Unit Price",
          "total": "Total",
          "status": "Status",
          "actions": "Actions"
        }
      },
      "actions": {
        "void": "Void"
      },
      "modal": {
        "voidCharge": "Void Charge",
        "voidChargeConfirm": "Void charge {{code}} - {{description}} ({{amount}})?",
        "reason": "Reason *",
        "reasonPlaceholder": "Enter reason for voiding..."
      },
      "states": {
        "loading": "Loading charges...",
        "noCharges": "No charges found for this period",
        "voiding": "Voiding..."
      },
      "toast": {
        "voided": "Charge voided",
        "voidedError": "Failed to void charge",
        "reasonRequired": "Reason is required"
      }
    },
    "payments": {
      "title": "Payment Posting",
      "labels": {
        "dashboard": "Dashboard",
        "uploadEraEob": "Upload ERA/EOB",
        "postPayment": "Post Payment",
        "totalPaymentsPeriod": "Total Payments (Period)",
        "filters": "Filters",
        "cancel": "Cancel"
      },
      "placeholders": {
        "filterPatient": "Filter by patient..."
      },
      "aria": {
        "paymentDateFrom": "Payment date from",
        "paymentDateTo": "Payment date to"
      },
      "table": {
        "header": {
          "date": "Date",
          "patient": "Patient",
          "claimNumber": "Claim #",
          "amount": "Amount",
          "method": "Method",
          "reference": "Reference",
          "postedBy": "Posted By"
        }
      },
      "modal": {
        "postPayment": "Post Payment",
        "patientId": "Patient ID *",
        "claimId": "Claim ID (optional)",
        "claimIdHint": "Leave empty for unapplied payment",
        "amount": "Amount *",
        "method": "Method *",
        "referenceNumber": "Reference Number",
        "referenceHint": "Check number, transaction ID, etc.",
        "notes": "Notes"
      },
      "states": {
        "loading": "Loading payments...",
        "noPayments": "No payments found for this period",
        "posting": "Posting..."
      },
      "toast": {
        "posted": "Payment posted successfully",
        "postedError": "Failed to post payment",
        "patientAmountRequired": "Patient and amount are required",
        "validAmount": "Please enter a valid amount",
        "eraEobSoon": "ERA/EOB upload coming soon"
      }
    },
    "chargeForm": {
      "title": "Create Charge",
      "labels": {
        "patientId": "Patient ID *",
        "encounterId": "Encounter ID *",
        "chargeCode": "Charge Code *",
        "description": "Description",
        "cptCode": "CPT Code",
        "quantity": "Quantity *",
        "unitPrice": "Unit Price *"
      },
      "placeholders": {
        "chargeCode": "Search charge master...",
        "cptCode": "Search CPT procedure code..."
      },
      "buttons": {
        "cancel": "Cancel",
        "create": "Create Charge"
      },
      "toast": {
        "created": "Charge created",
        "createdError": "Failed to create charge"
      }
    },
    "claimForm": {
      "title": "Create Claim",
      "labels": {
        "patientId": "Patient ID *",
        "encounterId": "Encounter ID *",
        "payerId": "Payer ID *",
        "claimType": "Claim Type *",
        "diagnosisCodes": "Diagnosis Codes",
        "selectCharges": "Select Charges ({{selected}} selected)",
        "notes": "Notes"
      },
      "placeholders": {
        "diagnosisCodes": "Comma-separated ICD-10 codes (e.g. J06.9, R05)"
      },
      "buttons": {
        "cancel": "Cancel",
        "create": "Create Claim"
      },
      "toast": {
        "created": "Claim created",
        "createdError": "Failed to create claim"
      }
    },
    "paymentForm": {
      "title": "Post Payment",
      "labels": {
        "patientId": "Patient ID *",
        "claimId": "Claim ID",
        "amount": "Amount *",
        "method": "Payment Method *",
        "source": "Source",
        "referenceNumber": "Reference Number",
        "notes": "Notes"
      },
      "placeholders": {
        "claimId": "Optional — link to a claim",
        "reference": "Transaction or check reference"
      },
      "buttons": {
        "cancel": "Cancel",
        "post": "Post Payment"
      },
      "toast": {
        "recorded": "Payment recorded",
        "recordedError": "Failed to record payment"
      }
    },
    "denials": {
      "title": "Denial Management",
      "subtitle": "Track and manage billing claim denials",
      "placeholders": {
        "search": "Search claims..."
      },
      "filter": {
        "all": "All"
      },
      "checkbox": {
        "assignedToMe": "Assigned to me"
      },
      "table": {
        "header": {
          "claimNumber": "Claim #",
          "patient": "Patient",
          "denialCode": "Denial Code",
          "denialReason": "Denial Reason",
          "amount": "Amount",
          "daysRemaining": "Days Remaining",
          "status": "Status",
          "assignedTo": "Assigned To",
          "actions": "Actions"
        }
      },
      "actions": {
        "review": "Review",
        "appeal": "Appeal",
        "writeOff": "Write Off",
        "cancel": "Cancel"
      },
      "modal": {
        "appealReason": "Appeal Reason",
        "appealPlaceholder": "Describe the reason for appeal...",
        "submitAppeal": "Submit Appeal",
        "writeOffTitle": "Write Off Denial",
        "writeOffConfirm": "Are you sure you want to write off claim {{claimNumber}} for {{amount}}? This action cannot be undone.",
        "writeOffButton": "Write Off"
      },
      "states": {
        "loading": "Loading denials...",
        "noDenials": "No denials found",
        "submitting": "Submitting..."
      },
      "toast": {
        "updateError": "Failed to update denial status",
        "movedToReview": "Claim {{claimNumber}} moved to review",
        "appealSubmitted": "Appeal submitted",
        "writtenOff": "Claim {{claimNumber}} written off"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
